import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=ece5a394&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ece5a394')) {
      api.createRecord('ece5a394', component.options)
    } else {
      api.reload('ece5a394', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=ece5a394&", function () {
      api.rerender('ece5a394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vug0To52u0oP/JS/videoIframe.vue"
export default component.exports